import React from 'react';
import IsMobileContext from './isMobileContext';


const IsMobileState = props => {
    function isMobileUse(){
        if (
            (navigator.userAgent.match("Android")) ||
            (navigator.userAgent.match("webOS")) ||
            (navigator.userAgent.match("iPhone")) ||
            (navigator.userAgent.match("iPod")) ||
            (navigator.userAgent.match("iPad")) ||
            (navigator.userAgent.match("BlackBerry"))
        ){ return true
        } else {return false}
    }
    return (
        <IsMobileContext.Provider
            value={{
                isMobileUse
            }}
        >{props.children}

        </IsMobileContext.Provider>
    )
}
export default IsMobileState;
